<template>
  <div>
    <el-input
          class="credit-input"
          v-model="start"
          oninput="value=value.replace(/[^0-9.]/g,'')"
          @input="handleInput($event, 0)"
        >
        </el-input
        ><span class="sepertor">至</span>
        <el-input
          class="credit-input"
          v-model="end"
          oninput="value=value.replace(/[^0-9.]/g,'')"
          @input="handleInput($event, 1)"
        >
        </el-input>
  </div>
</template>
<script>
export default {
  name: "RangeInput",
  // 接受父组件的值
  props: {
  },
  data() {
    return {
      start: null,
      end: null,
    };
  },
  methods: {
    reset() {
      this.end = null
      this.start = null
      this.$emit("change", [this.start, this.end]);
    },
    handleInput(value, type) {
      let changeValue = value
      if (value != "") {
        if (value.indexOf(".") > -1) {
          changeValue = value.slice(0, value.indexOf(".") + 3);
        } 
        if (type == 1) {
          this.end = changeValue
        } else this.start = changeValue
      } else {
        if (type == 1) {
          this.end = null
        } else this.start = null
      }
      this.$emit("change", [this.start, this.end]);
    },
  }
};
</script>
<style lang="scss" scoped>
/deep/ .credit-input {
    width: 80px;
    border-radius: 2px;
    // border: 1px solid #dcdfe6;
    height: 30px;
    color: #606266;
    outline: none;
    -webkit-appearance: none;
    background-color: #ffffff;
    background-image: none;
    // padding: 0 10px;
    &:focus {
      border-color: #3a85ff;
    }
  }

  .sepertor {
    margin: 0 10px;
  }
</style>